import axios from 'axios';
import { HttpClient } from '../types/sidekick';
import config from '../app/config';
import { resolveActiveTenantCode } from '../utils/tenantSession';

const getAuthToken = () => localStorage.getItem('accessToken');

/**
 * Helper function to determine the tenant to use for API requests
 * @returns {string} The tenant to use for API requests
 */
const getTenantForRequest = (): string => {
    let userDefaultTenant = '';
    try {
        // Try to get user details from EUM-specific storage
        const userDetailsEUM = localStorage.getItem('userDetailsEUM');
        if (userDetailsEUM) {
            const userData = JSON.parse(userDetailsEUM);
            userDefaultTenant = resolveActiveTenantCode(userData);
        }

        // Fall back to the auth claims snapshot if EUM details are not available yet.
        if (!userDefaultTenant) {
            const userDetails = localStorage.getItem('userDetails');
            if (userDetails) {
                const userData = JSON.parse(userDetails);
                userDefaultTenant = resolveActiveTenantCode(userData);
            }
        }
    } catch (error) {
        console.error('Error parsing user details:', error);
    }

    return userDefaultTenant;
};

/**
 * Creates an axios instance configured for the Sidekick API
 * This is separate from the main API client to allow for a different base URL
 * @param {string} customTenant - Optional tenant ID to override the default tenant
 * @returns {HttpClient} Configured axios instance
 */
const getSidekickHttpClient = (customTenant?: string): HttpClient => {
    const tenantToUse = customTenant || getTenantForRequest();

    return axios.create({
        baseURL: config.sidekickApiBaseUrl,
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${getAuthToken()}`,
            'X-Tenant': tenantToUse
        }
    });
};


export default getSidekickHttpClient;